import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import { createMetaManager } from 'vue-meta'

import { Modal } from '@kouts/vue-modal'
import '@kouts/vue-modal/dist/vue-modal.css'
// Vue.config.productionTip = false

createApp(App).use(router).use(store).use(createMetaManager()).component('Modal', Modal).mount('#app')

// new Vue({
//   router,
//   store,
//   render: h => h(App)
// }).$mount('#app')
